module.exports = __webpack_public_path__ + "media/images/pic/courses/benefit06-48dcf9ac359cbf3103bdc6e86de9dad6.svg";